export const text = `<div class="form-item md">
    <label>label-content</label>
    <input type="text" placeholder="text" />
</div>`

export const rounded = `<div class="form-item md form-rounded">
<label>label-content</label>
<input type="text" placeholder="text" />
</div>`

export const underline = `<div class="form-item md form-underline">
<label>label-content</label>
<input type="text" placeholder="text" />
</div>`

export const group = `<div class="form-group md">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const groupUnderline = `<div class="form-group md form-underline">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const groupRounded = `<div class="form-group md form-rounded">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const row = `<div class="form-group md form-row">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const inline = `<div class="form-group md form-inline">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const inlineRow = `<div class="form-group md form-inline form-row">
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
    <div class="form-item">
        <label>text md</label>
        <input type="text" />
    </div>
</div>`

export const labelBefore = `<div class="form-item lg">
    <div class="input-label">
        <span>@</span>
        <input type="text" />
    </div>
</div>`

export const labelAfter = `div class="form-item lg">
    <div class="input-label">
        <input type="text" />
        <span>@</span>
    </div>
</div>`

export const labelUnderlineBefore = `<div class="form-item lg form-underline">
    <div class="input-label">
        <span>@</span>
        <input type="text" />
    </div>
</div>`

export const labelUnderlineAfter = `<div class="form-item lg form-underline">
    <div class="input-label">
        <input type="text" />
        <span>@</span>
    </div>
</div>`

export const labelRoundedBefore = `<div class="form-item lg form-rounded">
    <div class="input-label before">
        <span>@</span>
        <input type="text" />
    </div>
</div>`

export const labelRoundedAfter = `<div class="form-item lg form-rounded">
    <div class="input-label after">
        <input type="text" />
        <span>@</span>
    </div>
</div>`

export const labelWrongRightRounded = `<div class="form-item lg form-rounded">
    <div class="input-label">
        <input type="text" />
        <span>@</span>
    </div>
</div>`

export const labelWrongLeftRounded = `<div class="form-item lg form-rounded">
    <div class="input-label">
        <span>@</span>
        <input type="text" />
    </div>
</div>`